import { VERSION } from '../../constants';

export function Footer() {
  const apoiadores = [
    {
      src: '/images/logos/logo_acisa.png',
      alt: 'Logo ACISA',
    },
    {
      src: '/images/logos/logo_bombeiros.jpg',
      alt: 'Logo Bombeiros',
    },
    {
      src: '/images/logos/logo_iph.png',
      alt: 'Logo IPH',
    },
    {
      src: '/images/logos/logo_prefeitura_rolante.jpeg',
      alt: 'Logo Prefeitura Rolante',
    },
    {
      src: '/images/logos/logo_defesa_civil.png',
      alt: 'Logo Defesa Civil',
    },
    {
      src: '/images/logos/logo_ufrgs.png',
      alt: 'Logo UFRGS',
    },
    {
      src: '/images/logos/logo_gpden.png',
      alt: 'Logo GPDEN',
    },
    {
      src: '/images/logos/logo_staf.png',
      alt: 'Logo STAF',
    },
  ];

  return (
    <footer id="footer" className="footer light-background mt-auto">
      <div className="container">
        <div className="row g-4">
          <div className="col-md-2 mb-3 mb-md-0">
            <div className="widget">
              <p className="widget-heading">Realização:</p>
              <img
                src="/images/logos/logo_ifrs_rolante.png"
                alt="Image"
                className="img-fluid rounded"
              />
            </div>
          </div>

          <div className="col-md-10 pl-lg-5">
            <div className="widget">
              <p className="widget-heading">Apoio:</p>
              <div className="container">
                <div className="row justify-content-center">
                  <div className="d-flex flex-row justify-content-center align-items-center flex-wrap gap-4">
                    {apoiadores.map((apoiador, index) => (
                      <div className="col-auto" key={index}>
                        <img
                          src={apoiador.src}
                          alt={apoiador.alt}
                          className="img-fluid rounded-circle logo-img "
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright d-flex flex-column flex-md-row align-items-center justify-content-md-between">
          <p>
            ©<span>Copyright</span>
            <strong className="px-1 sitename">IFRS.</strong>
          </p>
          <div className="credits">Versão {`${VERSION}`}</div>
        </div>
      </div>
    </footer>
  );
}
